<template>
  <div class="footer">
    <div class="pc_divide-line" />

    <div class="describle">
      <p>{{ $t(globalConfig.LAB_SERVICE) }}</p>
      <i18n class="p-content" :path="globalConfig.LAB_ACCESS" tag="p">
        <a
          class="primary_color"
          style="box-shadow: 0 1px"
          place="link"
          target="_blank"
          :href="globalConfig.noticeCountries"
          >{{ $t("register.LAB_COUNTRIES") }}</a
        >
      </i18n>
      <template v-if="$root.currentType === 'curacao'">
        <p>{{ $t("register.LAB_BRAND_CO") }}</p>
        <p>
          {{ $t("register.LAB_GAMEBLING_CO") }} {{ $t("register.LAB_AGE_CO") }}
        </p>
      </template>
      <template v-else>
        <p>{{ $t("register.LAB_BRAND") }}</p>
        <p>{{ $t("register.LAB_GAMEBLING") }} {{ $t("register.LAB_AGE") }}</p>
      </template>
    </div>
    <div class="mobile_down">
      <!--      <div class="follow" v-if="!hidedata">-->
      <!--        <p class="title">{{ $t('register.LAB_FOLLOW') }}</p>-->
      <!--        <div>-->
      <!--          <a target="_blank"-->
      <!--             href="https://www.facebook.com/kkpokerglobal/?utm_source=KKpokerwebsite&utm_medium=websiteFB&utm_campaign=KKpokerwebsite">-->
      <!--            <img class="facebook-img" src="/static/img/home/icon_03.png"/>-->
      <!--          </a>-->
      <!--          <a target="_blank"-->
      <!--             href="https://www.instagram.com/kkpokerglobal/?utm_source=KKpokerwebsite&utm_medium=websiteIG&utm_campaign=KKpokerwebsite">-->
      <!--            <img class="ins-img" src="/static/img/home/icon_04.png"/>-->
      <!--          </a>-->
      <!--          <a target="_blank"-->
      <!--             href="https://twitter.com/kkpokerglobal?utm_source=KKpokerwebsite&utm_medium=websitetwitter&utm_campaign=KKpokerwebsite">-->
      <!--            <img class="twitter-img" src="/static/img/home/icon_05.png"/>-->
      <!--          </a>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="divide-line"></div>

      <div class="jump_btn">
        <a
          target="_blank"
          v-if="globalConfig.iconHref"
          :href="globalConfig.iconHref"
        >
          <img class="icon_06" :src="globalConfig.icon" />
        </a>
        <a
          target="_blank"
          :href="gliLink"
          ><img class="icon_07" src="/static/img/home/gli.jpeg"
        /></a>
        <a target="_blank" href="https://www.gamcare.org.uk/"
          ><img class="icon_08" src="/static/img/home/icon_08.png"
        /></a>
        <a target="_blank" href="https://www.begambleaware.org/"
          ><img class="icon_09" src="/static/img/home/GambleAware.png"
        /></a>
        <a><img class="icon_10" src="/static/img/home/icon_10.png" /></a>
      </div>

      <div class="divide-line"></div>

      <div class="content" v-if="!hidedata">
        <a target="_blank" :href="globalConfig.about">{{
          $t("register.LAB_ABOUT")
        }}</a>
        <br />
        <a target="_blank" :href="globalConfig.privacyPolicy">{{
          $t(globalConfig.LAB_POLICY)
        }}</a>
        <br />
        <a target="_blank" :href="globalConfig.termsOfService">{{
          $t("register.LAB_TERM")
        }}</a>
      </div>
      <div class="content" v-if="hidedata"></div>

      <div class="copyright">
        <strong>{{
          $t("register.LAB_COPY", { link: new Date().getFullYear() })
        }}</strong>
      </div>
    </div>
    <div class="pc_down">
      <div class="divide-line"></div>

      <div class="jump_btn">
        <a
          target="_blank"
          v-if="globalConfig.iconHref"
          :href="globalConfig.iconHref"
          ><img class="icon_06" :src="globalConfig.icon"
        /></a>
        <a
          target="_blank"
          :href="gliLink"
          ><img class="icon_07" src="/static/img/home/gli.jpeg"
        /></a>
        <a target="_blank" href="https://www.gamcare.org.uk/"
          ><img class="icon_08" src="/static/img/home/icon_08.png"
        /></a>
        <a target="_blank" href="https://www.begambleaware.org/"
          ><img class="icon_09" src="/static/img/home/GambleAware.png"
        /></a>
        <a><img class="icon_10" src="/static/img/home/icon_10.png" /></a>
      </div>
      <div class="follow" v-if="!hidedata && $root.currentType !== 'curacao'">
        <div>
          <a
            target="_blank"
            href="https://www.facebook.com/kkpokerglobal/?utm_source=KKpokerwebsite&utm_medium=websiteFB&utm_campaign=KKpokerwebsite"
          >
            <img class="facebook-img" src="/static/img/home/icon_03.png" />
          </a>
          <a
            target="_blank"
            href="https://www.instagram.com/kkpokerglobal/?utm_source=KKpokerwebsite&utm_medium=websiteIG&utm_campaign=KKpokerwebsite"
          >
            <img class="ins-img" src="/static/img/home/icon_04.png" />
          </a>
          <a
            target="_blank"
            href="https://twitter.com/kkpokerglobal?utm_source=KKpokerwebsite&utm_medium=websitetwitter&utm_campaign=KKpokerwebsite"
          >
            <img class="twitter-img" src="/static/img/home/icon_05.png" />
          </a>
        </div>
      </div>
      <div class="content" v-if="!hidedata && !isWorldPlatform">
        <a target="_blank" :href="globalConfig.about">{{
          $t("register.LAB_ABOUT")
        }}</a>
        <br />
        <a target="_blank" :href="globalConfig.privacyPolicy">{{
          $t(globalConfig.LAB_POLICY)
        }}</a>
        <br />
        <a target="_blank" :href="globalConfig.termsOfService">{{
          $t("register.LAB_TERM")
        }}</a>
      </div>
      <div class="content" v-if="hidedata"></div>

      <div class="copyright">
        <strong>{{ $t("register.LAB_COPY", { link: currentYear }) }}</strong>
      </div>
    </div>
  </div>
</template>

<script>
import { worldPlatform } from "../../configs/worldSetting";

export default {
  data() {
    const res = JSON.parse(localStorage.getItem("legal"));
    const isWorldPlatform = worldPlatform.includes(res.platform);

    return {
      isWorldPlatform,
      input: "",
      show: false,
      FB_VERSON: "",
      checked: false,
      subscribe_error: "",
      subscribe_step: 0,
      noticeUrl: `${process.env.VUE_APP_NOTICE_KKPOKER}/mobile/restricted_territory`,
      currentYear: new Date().getFullYear(),
      gliLink: 'https://access.gaminglabs.com/Certificate/Index?i=429'
    };
  },
  props: ["hidedata"],
  mounted () {
    let currentType =  JSON.parse(localStorage.getItem('legal')).currentType;
    console.log('currentType', currentType);
    this.gliLink = currentType === 'curacao' ? 'https://access.gaminglabs.com/Certificate/Index?i=429' : 'https://access.gaminglabs.com/Certificate/Index?i=372';
    console.log(this.gliLink);
    
    
  },
  methods: {
    toBottom() {
      if (
        navigator.userAgent.indexOf("Android") > -1 ||
        navigator.userAgent.indexOf("Adr") > -1
      ) {
        document.querySelector(".footer").scrollIntoView(true);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.footer .pc_down {
  display: none;
  .follow {
    display: flex;
    justify-content: center;
    padding: 0.4rem;
    a {
      margin: 0 0.3rem;
    }
    .facebook-img {
      width: 0.47rem;
    }

    .ins-img {
      width: 0.7rem;
    }

    .twitter-img {
      width: 0.86rem;
    }
  }
  .jump_btn {
    width: 12rem;
    justify-content: space-evenly;
    .icon_09 {
      width: 3.2rem;
    }
  }
  .content {
    display: flex;
    width: 50%;
    justify-content: space-evenly;
    margin-right: 0px;
    a {
      text-decoration: underline !important;
      font-size: 0.27rem;
    }
  }
  .copyright p {
    font-size: 0.27rem;
  }
}

.desktop {
  .footer {
    width: 19rem;

    .mobile_down {
      display: none;
    }

    .pc_down {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .pc_divide-line {
    display: block;
  }

  .footer .describle {
    margin-top: 40px;

    p {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 0.3rem;
      line-height: 0.47rem;
      letter-spacing: 0.005rem;
      color: rgba(255, 255, 255, 0.5);
    }
  }
}

.pc_divide-line {
  display: none;
  width: 100%;
  height: 1px;
  background-color: #444444;
}

.footer {
  position: relative;
  font-size: 24px;
  color: #fff;
  background-color: #151515;
  padding: 60px 40px;

  .describle {
    p {
      font-size: 20px;
      color: #e7e7e7;
      line-height: 36px;
      margin-bottom: 16px;
      font-weight: 100;

      a {
        font-size: 20px;
        line-height: 36px;
      }
    }

    margin-bottom: 40px;
  }

  .divide-line {
    width: 100%;
    height: 1px;
    background-color: #444444;
  }

  .follow {
    padding: 34px 0px;

    .title {
      margin-bottom: 20px;
      color: #8a8a8a;
      font-size: 18px;
    }

    img {
      display: inline-block;
    }

    a {
      display: inline-block;
      margin-right: 48px;
      vertical-align: middle;
    }

    .facebook-img {
      width: 24px;
    }

    .ins-img {
      width: 38px;
    }

    .twitter-img {
      width: 47px;
    }
  }

  .jump_btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 50px 0px 40px 0px;
    text-align: center;

    a {
      display: inline-block;
      margin: 0px 10px 25px 10px;
      cursor: pointer;
    }

    img {
      display: inline-block;
      vertical-align: middle;
      // margin: 0px 16px;
    }

    .icon_06 {
      width: 76px;
    }

    .icon_07 {
      width: 97px;
    }

    .icon_08 {
      width: 89px;
    }

    .icon_09 {
      width: 165px;
    }

    .icon_10 {
      width: 48px;
    }
  }

  .content {
    padding: 20px 0px;
    display: inline-block;
    margin-right: 100px;

    a {
      color: #ffffff;
      font-size: 24px;
      margin: 10px 0px;
      display: inline-block;
      // box-shadow: 0 1PX;
    }
  }

  .copyright p {
    color: #8a8a8a;
    font-size: 18px;
  }
}
</style>
